import { render, staticRenderFns } from "./customer-info-dialog.vue?vue&type=template&id=c88425ac&scoped=true"
import script from "./customer-info-dialog.vue?vue&type=script&lang=js"
export * from "./customer-info-dialog.vue?vue&type=script&lang=js"
import style0 from "./customer-info-dialog.vue?vue&type=style&index=0&id=c88425ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88425ac",
  null
  
)

export default component.exports